import { Input, message, Modal } from 'antd';
import React, { useState } from 'react';
import { createFolder, folderList } from '../../../../services/file';
import { t } from '../../../../locales';

import './index.scss';
import useFolderStore from '../../../../stores/folderStore';

type Props = {
  onSuccess?: () => void,
  onCancel?: () => void,
}
// 更全面的版本（推荐）
function validateInput(value: string) {
    // 这个正则允许：字母、数字、汉字、空格、下划线、中划线
    // 不允许：特殊字符 / \ ' " < > ; : ! @ # $ % ^ & * ( ) = + [ ] { } | , . ? ` ~
    const regex = /^[a-zA-Z0-9\u4e00-\u9fa5\s\-_]+$/;
    return regex.test(value);
}

const AddFolder = (props: Props) => {
  const { onSuccess, onCancel } = props;
  const [renameModalVisible, setRenameModalVisible] = useState(true);
  const [newFileName, setNewFileName] = useState('');
  const [renameLoading, setRenameLoading] = useState(false);
  const { setFolders } = useFolderStore.getState();
  const { folders } = useFolderStore();

  const handleRenameCancel = () => {
    setRenameModalVisible(false);
    setNewFileName('');
    onCancel?.();
  }

  const handleRenameKeyPress = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === 'Enter') {
      handleRenameSubmit();
    }
  }

  const handleRenameSubmit = async () => {
    const val = newFileName.trim()
    if (!val) {
      message.warning(t('file.addFolderPlaceholder'));
      return;
    }
    const folderNames = folders.map(i => i.folderName)
    if (folderNames.includes(val)) {
      message.warning('文件夹已存在');
      return;
    }

    if (!validateInput(val)) {
      message.warning('名称包含非法字符,请修改后重试');
      return;
    }

    setRenameLoading(true);
    try {
      // 调用重命名接口
      await createFolder(val);

      message.success(t('file.createFolderSuccess'));
      setRenameModalVisible(false);
      setNewFileName('');

      // 调用成功回调
      onSuccess?.();
      const res3 = await folderList()
      setFolders(res3.folders)

    } catch (error) {
      message.error(t('file.createFolderFail'));
    } finally {
      setRenameLoading(false);
    }
  }

  return (
    <Modal
      title={t('file.AddFolder')}
      visible={renameModalVisible}
      onCancel={handleRenameCancel}
      onOk={handleRenameSubmit}
      confirmLoading={renameLoading}
      okText={t('common.ok')}
      cancelText={t('file.renameCancel')}
      destroyOnClose
      maskClosable={false}
      width={460}
      className="add-folder-modal"
    >
      <div className="add-folder-input-container">
        <Input
          placeholder={t('file.addFolderPlaceholder')}
          value={newFileName}
          onChange={(e) => setNewFileName(e.target.value)}
          onKeyDown={handleRenameKeyPress}
          autoFocus
          maxLength={20}
          className="add-folder-input"
        />
      </div>
    </Modal>
  )

}

export default AddFolder;